module.exports = __webpack_public_path__ + "static/media/3. Cilindro 2, Resina cristal y acrílico, 59 x 76 x 8 cm, 2020 copy.69f3a12c.png";